import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, FileText } from 'lucide-react';

export const SubsidiesCTA = () => (
  <section className="py-24 bg-[#0f172a]" data-testid="subsidies-cta">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <FileText className="w-16 h-16 text-[#00bcd4] mx-auto mb-6" />
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">
          Not Sure Which Scheme Fits Your Business?
        </h2>
        <p className="text-slate-400 max-w-2xl mx-auto mb-8">
          Our experts will analyze your business profile and recommend the most suitable 
          subsidy schemes to maximize your benefits.
        </p>
        <Link
          to="/contact"
          data-testid="subsidies-contact-cta"
          className="gradient-btn px-10 py-4 rounded-full font-medium text-white inline-flex items-center gap-2"
        >
          Get Free Consultation
          <ArrowRight size={18} />
        </Link>
      </motion.div>
    </div>
  </section>
);
